import { ApiUserRepository } from "../../infrastructure/repositories/ApiUserRepository";
import { ErrorHandler, ERROR_CONTEXTS } from "../../shared/utils/errorHandler";
import { logger } from "../../infrastructure/services/LoggerService";
export class OnboardingUseCases {
    constructor() {
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.repository = new ApiUserRepository();
    }
    /**
     * Create Adyen link for onboarding process
     * @returns Promise<string> - Returns the Adyen returnUrl for onboarding
     */
    async createAdyenOnboardingLink() {
        try {
            const returnUrl = await this.repository.createAdyenLink();
            logger.debug("Adyen onboarding link created successfully:", returnUrl);
            return returnUrl;
        }
        catch (error) {
            // Use the centralized error handler with automatic navigation logic
            ErrorHandler.handleApiError(error, ERROR_CONTEXTS.ONBOARDING_LINK_CREATION);
            // Throw the error to stop execution
            throw error;
        }
    }
}
